// extracted by mini-css-extract-plugin
export default {"SVG":"Notfound_SVG__-Kesb","Notfound":"Notfound_Notfound__kzJnk","Link":"Notfound_Link__e+KQA","Title":"Notfound_Title__cDNnP","Type":"Notfound_Type__jwKzK"};